import { ISessionTranscriptSummary } from './session-transcript-summary.types';
import * as constants from './session-transcript-summary.constants';

export interface IStoreSessionTranscriptSummaryAction {
  type: typeof constants.STORE_SESSION_TRANSCRIPT_SUMMARY;
  payload: ISessionTranscriptSummary;
}

export interface IClearSessionTranscriptSummaryAction {
  type: typeof constants.CLEAR_SESSION_TRANSCRIPT_SUMMARY;
}

export type SessionTranscriptSummaryActionTypes =
  | IStoreSessionTranscriptSummaryAction
  | IClearSessionTranscriptSummaryAction;

export const storeSessionTranscriptSummary = (
  transcriptSummary: ISessionTranscriptSummary,
): IStoreSessionTranscriptSummaryAction => ({
  type: constants.STORE_SESSION_TRANSCRIPT_SUMMARY,
  payload: transcriptSummary,
});

export const clearSessionTranscriptSummary = (): IClearSessionTranscriptSummaryAction => ({
  type: constants.CLEAR_SESSION_TRANSCRIPT_SUMMARY,
});
